import { render, staticRenderFns } from "./beUpdating.vue?vue&type=template&id=74e87720&scoped=true&"
import script from "./beUpdating.vue?vue&type=script&lang=js&"
export * from "./beUpdating.vue?vue&type=script&lang=js&"
import style0 from "./beUpdating.vue?vue&type=style&index=0&id=74e87720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e87720",
  null
  
)

export default component.exports